import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scope for the supervision Functions API (the SPA app registration exposes
// access_as_user). Tokens with this audience are validated by the backend AuthMiddleware.
export const apiScopes = [
  `api://${import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`,
];

// Interactive login requests the API scope so the backend bearer token is minted at sign-in
// and cached — otherwise acquireTokenSilent must reach the authorize endpoint via a hidden
// iframe to get it, which fails once the SPA refresh token expires.
export const loginRequest = {
  scopes: apiScopes,
};
